import { Injectable, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ForbiddenPageService {
  private readonly router = inject(Router);
  private readonly titleService = inject(Title);
  private readonly isForbiddenSignal = signal(false);

  readonly isForbidden = this.isForbiddenSignal.asReadonly();

  constructor() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(() => this.isForbiddenSignal.set(false));
  }

  showForbiddenPage(): void {
    if (this.isForbiddenSignal()) {
      return;
    }
    this.isForbiddenSignal.set(true);
    this.titleService.setTitle('Access restricted');
  }
}
